import React, { Component } from 'react';

import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Modal from 'react-bootstrap/Modal';

import { addMerchantCategory } from '../../api/merchant';
import CancelAlertPopup from '../../components/CancelAlertPopup/CancelAlertPopup';
import {
  INITIAL_STATE,
  CATEGORY_FORM_FIELDS as FORM_FIELDS,
  validateForm,
  validateUrlField,
} from './AddCategoryConstants';

import styles from './AddCategory.module.scss';

class AddCategory extends Component {
  state = INITIAL_STATE;

  handleSubmit = async (event) => {
    const form = event.currentTarget;
    event.preventDefault();

    // Run JS validation
    const validationErrors = validateForm(this.state);
    if (Object.keys(validationErrors).length > 0) {
      this.setState({ fieldErrors: validationErrors });
      return;
    }

    // Clear errors and proceed
    this.setState({ fieldErrors: {} });

    try {
      this.setState({
        loading: true,
        apiSuccessResponse: null,
        apiErrorResponse: null,
        isFailed: false,
        isSuccess: false,
      });
      const request = {
        name: this.state.name,
        imgUrl: this.state.imgUrl,
        description: this.state.description,
      };
      const response = await addMerchantCategory(request, this.props.token);
      this.setState({
        isSuccess: true,
        apiSuccessResponse: response.message,
        loading: false,
        isFailed: false,
        fieldErrors: {},
      });
      this.props.getCategories();
    } catch (err) {
      this.setState({
        apiErrorResponse: err.message,
        loading: false,
        isFailed: true,
        apiSuccessResponse: null,
      });
    }
  };

  handleClose = () => {
    if (this.state.changes && !this.state.isSuccess) {
      this.handleCancel();
    } else {
      this.setInitialValues();
      this.props.handleCloseModalShow();
    }
  };

  setInitialValues = () => {
    this.setState(INITIAL_STATE);
  };

  handleInputChange = (event) => {
    let { name, value } = event.target;
    let item = this.state[name];
    if (item.length === 0) {
      value = value.trim();
    }

    let urlError = '';
    if (name === 'imgUrl' && value) {
      urlError = validateUrlField(value);
    }

    this.setState({
      [name]: value,
      isSuccess: false,
      apiSuccessResponse: null,
      apiErrorResponse: null,
      isFailed: false,
      changes: true,
      fieldErrors: {
        ...this.state.fieldErrors,
        [name]: urlError || '',
      },
    });
  };

  handleClear = () => {
    this.setInitialValues();
    this.handleCancel();
    this.props.handleCloseModalShow();
  };

  handleCancel = () => {
    this.setState({
      showCancelPopup: !this.state.showCancelPopup,
    });
  };

  renderInputField = (name, label, value, onChange, max, as, required) => {
    return (
      <Form.Group as={Row}>
        <Col>
          <Form.Label>
            {label}
            {required === 'required' && <span className={styles.required__asterisk}>*</span>}
          </Form.Label>
          <Form.Control
            name={name}
            value={value}
            onChange={onChange}
            maxLength={max}
            isInvalid={!!this.state.fieldErrors[name]}
            placeholder={
              name === 'imgUrl'
                ? 'https://example.com/sample_image.png'
                : `Enter ${label.toLowerCase()}`
            }
            as={as}
          />
          {this.state.fieldErrors[name] && (
            <Form.Control.Feedback type='invalid' style={{ display: 'block' }}>
              {this.state.fieldErrors[name]}
            </Form.Control.Feedback>
          )}
        </Col>
      </Form.Group>
    );
  };

  renderSuccessResponse = () => {
    return <span className={styles.success_msg}>{this.state.apiSuccessResponse}</span>;
  };

  renderErrorResponse = () => {
    return <span className={styles.err_msg}>{this.state.apiErrorResponse}</span>;
  };

  renderModal = () => {
    const { showModal, handleModalShow } = this.props;
    return (
      <Modal
        show={showModal}
        onHide={handleModalShow}
        backdrop='static'
        keyboard={false}
        size='lg'
        aria-labelledby='contained-modal-title-vcenter'
        centered
        animation={false}
      >
        <Modal.Header>
          <Modal.Title>Create new merchant category here</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form onSubmit={this.handleSubmit} noValidate>
            {FORM_FIELDS.map(({ name, label, type, placeholder, required, maxLength }) => (
              <div key={name}>
                {this.renderInputField(
                  name,
                  label,
                  this.state[name],
                  this.handleInputChange,
                  maxLength,
                  type === 'textarea' ? 'textarea' : 'input',
                  required ? 'required' : ''
                )}
              </div>
            ))}

            <div className={styles.modal_footer}>
              <Button
                variant='secondary'
                onClick={this.handleClose}
                className={styles.footer_btn}
              >
                Close
              </Button>

              <Button
                variant='primary'
                type='submit'
                className={styles.footer_btn}
                disabled={this.state.loading}
              >
                {this.state.loading ? 'Loading' : 'Create'}
              </Button>
            </div>
          </Form>
        </Modal.Body>

        <Modal.Footer />

        <div className={styles.api_response_block}>
          {this.state.isSuccess
            ? this.renderSuccessResponse()
            : this.state.isFailed
              ? this.renderErrorResponse()
              : null}
        </div>
      </Modal>
    );
  };

  render() {
    return (
      <div>
        {this.renderModal()}
        <CancelAlertPopup
          show={this.state.showCancelPopup}
          alertMessage='Are you sure you want to cancel ?'
          handleYesBtnClick={this.handleClear}
          handleNoBtnClick={this.handleCancel}
        />
      </div>
    );
  }
}

export default AddCategory;
